import React, { Component } from "react";
import { Link } from "react-router-dom";
import _ from "lodash";
import { Pagination } from "antd";
import { withRedux } from "../hoc";
import { stripHtml } from "../utils";
import { LayoutPage, ArticleItem, BackgroundImage, Button } from "../components";

const pageSize = 6;

const mapStateToProps = ({ language, t, posts, newsPage }) => {
  const data = _.get(posts, "data");
  const news = _.filter(data, item => {
    const categoryID = _.get(item, "category.id");
    return categoryID === _.toNumber(process.env.REACT_APP_POST_NEWS_ID);
  });
  const orderNews = _.sortBy(news, "updated_at");
  return {
    language,
    t,
    news: orderNews,
    newsPage: _.get(newsPage, "data")
  };
};

@withRedux(mapStateToProps)
export default class News extends Component {
  state = {
    currentPage: 1
  };
  onChangePage = page => {
    this.setState({
      currentPage: page
    });
  };
  render() {
    const { news, t, newsPage } = this.props;
    const { currentPage } = this.state;
    const newshighlight = _.get(news, "0");

    const otherNews = _.slice(news, 1, _.size(news));
    const orderotherNews = _.sortBy(otherNews, "updated_at");

    const video = _.get(newsPage, "video");
    const imageBanner = _.get(newsPage, "imageBanner");
    const imageBannerMobile = _.get(newsPage, "imageBannerMobile");

    // getPagination
    const showItem = _.slice(orderotherNews, (currentPage - 1) * pageSize, currentPage * pageSize);

    return (
      <div className="news-page">
        <LayoutPage
          pageName="NEWS"
          media={video}
          image={imageBanner}
          imageMobile={imageBannerMobile}
        />
        <div className="container">
          <div className="container-news-highlight">
            <div className="row no-gutters">
              <div className="col-lg-6">
                <div className="container-highlight-image">
                  <BackgroundImage image={_.get(newshighlight, "image")} className="img" />
                </div>
              </div>
              <div className="col-lg-6 align-self-end">
                <div className="container-highlight-content">
                  <div className="highlight-date">
                    <p>{_.get(newshighlight, "date")}</p>
                  </div>
                  <div className="highlight-title">
                    <h2>{t(_.get(newshighlight, "title"))}</h2>
                  </div>
                  <div className="highlight-content">
                    <p
                      className="benefits-detail"
                      dangerouslySetInnerHTML={{
                        __html: stripHtml(t(_.get(newshighlight, "description")))
                      }}
                    />
                  </div>
                  <div className="container-highlight-button">
                    <Link to={`/news/detail/${_.get(news, "0.id")}`}>
                      <Button ghost bordercolor="#ffb400" className="article-highlight-button">
                        Read more <i className="fa fa-arrow-right" />
                      </Button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container-all-article">
            <div className="row">
              {_.map(showItem, (item, key) => {
                return (
                  <div className="col-lg-4 col-md-6" key={key}>
                    <div className="news-item">
                      <ArticleItem
                        data={item}
                        pathOnClick={`/news/detail/${item.id}`}
                        darkFont
                        showDate
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="container-pagination">
            <Pagination
              current={currentPage}
              defaultPageSize={6}
              total={_.size(news)}
              onChange={this.onChangePage}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/News.js